import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ERoutes } from "../../constants/routes";
import { ImpersonateUserPayload, SuperuserState } from "./types";
import { User } from "../../types/auth";

export const initialState: SuperuserState = {
  user: null,
  supermode: false,
  loading: false,
  pendingNavigate: null,
};

export const impersonateUser = createAction<ImpersonateUserPayload>("superuser/impersonateUser");
export const stopImpersonation = createAction("superuser/stopImpersonation");

const superuserSlice = createSlice({
  name: "superuser",
  initialState,
  reducers: {
    impersonateUserSuccess: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.supermode = true;
    },
    impersonateUserFailure: (state) => {
      state.user = null;
      state.supermode = false;
      state.loading = false;
      state.pendingNavigate = null;
    },
    impersonationComplete: (state) => {
      state.loading = false;
      state.pendingNavigate = ERoutes.Overview;
    },
    stopImpersonationSuccess: (state) => {
      state.user = null;
      state.supermode = false;
    },
    stopImpersonationComplete: (state) => {
      state.loading = false;
      state.pendingNavigate = ERoutes.Overview;
    },
    clearPendingNavigate: (state) => {
      state.pendingNavigate = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(impersonateUser, (state) => {
      state.loading = true;
      state.pendingNavigate = null;
    });
    builder.addCase(stopImpersonation, (state) => {
      state.loading = true;
      state.pendingNavigate = null;
    });
  },
});

export const {
  impersonateUserSuccess,
  impersonateUserFailure,
  impersonationComplete,
  stopImpersonationSuccess,
  stopImpersonationComplete,
  clearPendingNavigate,
} = superuserSlice.actions;

export default superuserSlice.reducer;
